<template>
  <div class="bind-page">
    <el-form
      :model="bindForm"
      :rules="bindFormRules"
      ref="bindFormRef"
      class="bind-form"
      label-width="0px"
    >
      <h3>请绑定您的艾嘉加账号</h3>
      <el-form-item prop="account">
        <el-input
          v-model="bindForm.account"
          placeholder="请输入账号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          placeholder="请输入密码"
          v-model="bindForm.password"
        ></el-input>
      </el-form-item>
      <div class="footer">
        <el-button
          class="bind-btn"
          type="primary"
          v-loading="loading"
          @click="handleSubmitBindForm"
          >绑定</el-button
        >
        <el-button @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import loginFormjRules from '@utils/rules/loginFormRules'
import { encryption } from '@utils/crypto'
import { validateForm } from '@utils'
import { bindAccount } from '@api/login'
import { namespace } from 'vuex-class'

const moduleUser = namespace('user')

@Component
export default class Login extends Vue {
  bindForm = {
    account: '',
    password: '',
    wid: 0,
  }
  loading = false

  @moduleUser.State
  wid

  @moduleUser.Mutation
  SET_TOKEN

  created() {
    this.bindFormRules = loginFormjRules
    this.bindForm.wid = this.wid
  }

  async postBindForm() {
    this.loading = true
    // const user = encryption(this.bindForm)
    const user = encryption({
      data: this.bindForm,
      encryptArr: ['password'],
    })

    try {
      const { message, code } = await bindAccount({
        account: user.account.trim(),
        password: user.password,
        wid: user.wid,
      })
      console.log(this.$route)
      this.$message.warning(message)
      if (code === 0) {
        this.$router.push({
          path: '/login',
          query: {
            tab: 'wechat',
          },
        })
      }
    } catch (error) {
      console.log(error)
    }
    this.loading = false
  }
  async handleSubmitBindForm() {
    const valid = await validateForm.call(this, 'bindFormRef')
    if (valid) {
      await this.postBindForm()
    } else {
      this.$message.warning('表单有误')
    }
  }
  handleCancel() {
    this.$router.push({ path: '/login' })
  }
}
</script>
<style lang="scss" scoped>
@import '@styles/variable.scss';
.bind-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f8f8;
  .bind-form {
    width: 300px;
    height: 150px;
    text-align: center;
    h3 {
      // font-size: 14px;
      margin-bottom: 20px;
    }
    .bind-btn {
      background: $color-text-bg;
      border-color: $color-text-bg;
    }
  }
}
</style>
